/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_No_IntegrityInputs */



/**
* | output |
* | --- |
* | "No hash pinned" |
*
* @param {Partner_Connectors_No_IntegrityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_no_integrity = /** @type {((inputs?: Partner_Connectors_No_IntegrityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_No_IntegrityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Hash festgelegt")
	return /** @type {LocalizedString} */ ("No hash pinned")
});